import { API_USER_SERVICE } from "../config/Constants";
import { IBuildingRequestDTO, IBuildingDimensionsDTO, IFloorRequestDTO, IFloorDimensionsDTO, IRoomRequestDTO, IRoomDimensionsDTO, IRoomTemporaryDimensionsDTO, IRackRequestDTO, IRackDimensionsDTO, IBinRequestDTO, IBinDimensionsDTO } from "../interfaces/WarehouseSettings";
import { getRequest, postRequest, putRequest, deleteRequest } from "./Rest";

// Building APIs

export const getAllBuildings = async () => {
    const path = `${API_USER_SERVICE}/building`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

export const getAllBuildingsWithPagination = async (page: number = 0, size: number = 7) => {
    const path = `${API_USER_SERVICE}/building?page=${page}&size=${size}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

export const createBuilding = async (dto: IBuildingRequestDTO) => {
    const path = `${API_USER_SERVICE}/building`;
    const response = await postRequest(path, dto);
    return response;
};

export const updateBuilding = async (id: number, dto: IBuildingRequestDTO) => {
    const path = `${API_USER_SERVICE}/building/${id}`;
    const response = await putRequest(path, dto);
    return response;
};

export const getAvailableForFit = async (dto: IBuildingDimensionsDTO) => {
    const path = `${API_USER_SERVICE}/building/fit?length=${dto.length}&width=${dto.width}&height=${dto.height}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

export const getAvailableForTemporary = async (dto: IBuildingDimensionsDTO) => {
    const path = `${API_USER_SERVICE}/building/temporary?length=${dto.length}&width=${dto.width}&height=${dto.height}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

// Floor APIs

export const getAllFloors = async () => {
    const path = `${API_USER_SERVICE}/floor`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

export const createFloor = async (dto: IFloorRequestDTO) => {
    const path = `${API_USER_SERVICE}/floor`;
    const response = await postRequest(path, dto);
    return response;
};

export const updateFloor = async (id: number, dto: IFloorRequestDTO) => {
    const path = `${API_USER_SERVICE}/floor/${id}`;
    const response = await putRequest(path, dto);
    return response;
};

export const getFloorsByBuildingId = async (buildingId: number) => {
    const path = `${API_USER_SERVICE}/floor/byBuilding/${buildingId}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

export const getFloorsAvailableForFit = async (dto: IFloorDimensionsDTO) => {
    const path = `${API_USER_SERVICE}/floor/fit?length=${dto.length}&width=${dto.width}&height=${dto.height}&buildingId=${dto.buildingId}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

// Room APIs

export const getAllRooms = async () => {
    const path = `${API_USER_SERVICE}/room`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

export const createRoom = async (dto: IRoomRequestDTO) => {
    const path = `${API_USER_SERVICE}/room`;
    const response = await postRequest(path, dto);
    return response;
};

export const updateRoom = async (id: number, dto: IRoomRequestDTO) => {
    const path = `${API_USER_SERVICE}/room/${id}`;
    const response = await putRequest(path, dto);
    return response;
};

export const deleteRoom = async (id: number) => {
    const path = `${API_USER_SERVICE}/room/${id}`;
    const response = await deleteRequest(path);
    return response;
};

export const getRoomsByFloorId = async (floorId: number) => {
    const path = `${API_USER_SERVICE}/room/byFloor/${floorId}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

export const getRoomsAvailableForFit = async (dto: IRoomDimensionsDTO) => {
    const path = `${API_USER_SERVICE}/room/fit?length=${dto.length}&width=${dto.width}&height=${dto.height}&floorId=${dto.floorId}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

export const getRoomsAvailableForTemporary = async (dto: IRoomTemporaryDimensionsDTO) => {
    const path = `${API_USER_SERVICE}/room/temporary?length=${dto.length}&width=${dto.width}&height=${dto.height}&buildingId=${dto.buildingId}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

// Rack APIs

export const getAllRacks = async () => {
    const path = `${API_USER_SERVICE}/rack`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

export const createRack = async (dto: IRackRequestDTO) => {
    const path = `${API_USER_SERVICE}/rack`;
    const response = await postRequest(path, dto);
    return response;
};

export const updateRack = async (id: number, dto: IRackRequestDTO) => {
    const path = `${API_USER_SERVICE}/rack/${id}`;
    const response = await putRequest(path, dto);
    return response;
};

export const deleteRack = async (id: number) => {
    const path = `${API_USER_SERVICE}/rack/${id}`;
    const response = await deleteRequest(path);
    return response;
};

export const getRacksByRoomId = async (roomId: number) => {
    const path = `${API_USER_SERVICE}/rack/byRoom/${roomId}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

export const getRacksAvailableForFit = async (dto: IRackDimensionsDTO) => {
    const path = `${API_USER_SERVICE}/rack/fit?length=${dto.length}&width=${dto.width}&height=${dto.height}&roomId=${dto.roomId}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

// Bin APIs

export const getAllBins = async () => {
    const path = `${API_USER_SERVICE}/bin`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

export const createBin = async (dto: IBinRequestDTO) => {
    const path = `${API_USER_SERVICE}/bin`;
    const response = await postRequest(path, dto);
    return response;
};

export const updateBin = async (id: number, dto: IBinRequestDTO) => {
    const path = `${API_USER_SERVICE}/bin/${id}`;
    const response = await putRequest(path, dto);
    return response;
};

export const deleteBin = async (id: number) => {
    const path = `${API_USER_SERVICE}/bin/${id}`;
    const response = await deleteRequest(path);
    return response;
};

export const getBinsByRackId = async (rackId: number) => {
    const path = `${API_USER_SERVICE}/bin/byRack/${rackId}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

export const getBinsAvailableForFit = async (dto: IBinDimensionsDTO) => {
    const path = `${API_USER_SERVICE}/bin/fit?length=${dto.length}&width=${dto.width}&height=${dto.height}&rackId=${dto.rackId}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};
